import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { BaseEntity } from '../../models/base-entity';

export interface MakiIcon {
  path: string;
  key: string;
}
export interface FaIcon {
  keyWords: string[];
  key: string;
}

@Injectable({
  providedIn: 'root',
})
export class IconService {
  basePath = 'assets/maki-icons/';
  poiIcons: string[] = [
    'aerialway',
    'airfield',
    'airport',
    'alcohol-shop',
    'american-football',
    'amusement-park',
    'animal-shelter',
    'aquarium',
    'arrow',
    'art-gallery',
    'attraction',
    'bakery',
    'bank-JP',
    'bank',
    'bar',
    'barrier',
    'baseball',
    'basketball',
    'bbq',
    'beach',
    'beer',
    'bicycle-share',
    'bicycle',
    'blood-bank',
    'bowling-alley',
    'bridge',
    'building-alt1',
    'building',
    'bus',
    'cafe',
    'campsite',
    'car-rental',
    'car-repair',
    'car',
    'casino',
    'castle-JP',
    'castle',
    'caution',
    'cemetery-JP',
    'cemetery',
    'charging-station',
    'cinema',
    'circle-stroked',
    'circle',
    'city',
    'clothing-store',
    'college-JP',
    'college',
    'commercial',
    'communications-tower',
    'confectionery',
    'construction',
    'convenience',
    'cricket',
    'cross',
    'dam',
    'danger',
    'defibrillator',
    'dentist',
    'diamond',
    'doctor',
    'dog-park',
    'drinking-water',
    'elevator',
    'embassy',
    'emergency-phone',
    'entrance-alt1',
    'entrance',
    'farm',
    'fast-food',
    'fence',
    'ferry-JP',
    'ferry',
    'fire-station-JP',
    'fire-station',
    'fitness-centre',
    'florist',
    'fuel',
    'furniture',
    'gaming',
    'garden-centre',
    'garden',
    'gate',
    'gift',
    'globe',
    'golf',
    'grocery',
    'hairdresser',
    'harbor',
    'hardware',
    'heart',
    'heliport',
    'highway-rest-area',
    'historic',
    'home',
    'horse-riding',
    'hospital-JP',
    'hospital',
    'hot-spring',
    'ice-cream',
    'industry',
    'information',
    'jewelry-store',
    'karaoke',
    'landmark-JP',
    'landmark',
    'landuse',
    'laundry',
    'library',
    'lift-gate',
    'lighthouse-JP',
    'lighthouse',
    'lodging',
    'logging',
    'marae',
    'marker-stroked',
    'marker',
    'mobile-phone',
    'monument-JP',
    'monument',
    'mountain',
    'museum',
    'music',
    'natural',
    'nightclub',
    'observation-tower',
    'optician',
    'paint',
    'park-alt1',
    'park',
    'parking-garage',
    'parking-paid',
    'parking',
    'pharmacy',
    'picnic-site',
    'pitch',
    'place-of-worship',
    'playground',
    'police-JP',
    'police',
    'post-JP',
    'post',
    'prison',
    'racetrack-boat',
    'racetrack-cycling',
    'racetrack-horse',
    'racetrack',
    'rail-light',
    'rail-metro',
    'rail',
    'ranger-station',
    'recycling',
    'religious-buddhist',
    'religious-christian',
    'religious-jewish',
    'religious-muslim',
    'religious-shinto',
    'residential-community',
    'restaurant-bbq',
    'restaurant-noodle',
    'restaurant-pizza',
    'restaurant-seafood',
    'restaurant-sushi',
    'restaurant',
    'road-accident',
    'roadblock',
    'rocket',
    'school-JP',
    'school',
    'scooter',
    'shelter',
    'shoe',
    'shop',
    'skateboard',
    'skiing',
    'slaughterhouse',
    'slipway',
    'snowmobile',
    'soccer',
    'square-stroked',
    'square',
    'stadium',
    'star-stroked',
    'star',
    'suitcase',
    'swimming',
    'table-tennis',
    'taxi',
    'teahouse',
    'telephone',
    'tennis',
    'terminal',
    'theatre',
    'toilet',
    'toll',
    'town-hall',
    'town',
    'triangle-stroked',
    'triangle',
    'tunnel',
    'veterinary',
    'viewpoint',
    'village',
    'volcano',
    'volleyball',
    'warehouse',
    'waste-basket',
    'watch',
    'water',
    'waterfall',
    'watermill',
    'wetland',
    'wheelchair',
    'windmill',
    'zoo',
  ];

  themeIcons: string[] = [
    'fas fa-address-book',
    'fas fa-address-card',
    'fas fa-adjust',
    'fas fa-american-sign-language-interpreting',
    'fas fa-anchor',
    'fas fa-archive',
    'fas fa-area-chart',
    'fas fa-arrows',
    'fas fa-arrows-h',
    'fas fa-arrows-v',
    'fas fa-asl-interpreting',
    'fas fa-assistive-listening-systems',
    'fas fa-asterisk',
    'fas fa-at',
    'fas fa-audio-description',
    'fas fa-automobile',
    'fas fa-balance-scale',
    'fas fa-ban',
    'fas fa-bank',
    'fas fa-bar-chart',
    'fas fa-barcode',
    'fas fa-bars',
    'fas fa-bath',
    'fas fa-bathtub',
    'fas fa-battery',
    'fas fa-battery-empty',
    'fas fa-battery-full',
    'fas fa-battery-half',
    'fas fa-battery-quarter',
    'fas fa-battery-three-quarters',
    'fas fa-bed',
    'fas fa-beer',
    'fas fa-bell',
    'fas fa-bell-slash',
    'fas fa-bicycle',
    'fas fa-binoculars',
    'fas fa-birthday-cake',
    'fas fa-blind',
    'fa-brand fa-bluetooth',
    'fa-brand fa-bluetooth-b',
    'fas fa-bolt',
    'fas fa-bomb',
    'fas fa-book',
    'fas fa-bookmark',
    'fas fa-braille',
    'fas fa-briefcase',
    'fas fa-bug',
    'fas fa-building',
    'fas fa-bullhorn',
    'fas fa-bullseye',
    'fas fa-bus',
    'fas fa-cab',
    'fas fa-calculator',
    'fas fa-calendar',
    'fas fa-calendar-check',
    'fas fa-calendar-minus',
    'fas fa-calendar',
    'fas fa-calendar-plus',
    'fas fa-calendar-times',
    'fas fa-camera',
    'fas fa-camera-retro',
    'fas fa-car',
    'fas fa-caret-square-down',
    'fas fa-caret-square-left',
    'fas fa-caret-square-right',
    'fas fa-caret-square-up',
    'fas fa-cart-arrow-down',
    'fas fa-cart-plus',
    'fas fa-closed-captioning',
    'fas fa-certificate',
    'fas fa-check',
    'fas fa-check-circle',
    'fas fa-check-square',
    'fas fa-child',
    'fas fa-circle',
    'fas fa-circle-notch',
    'fas fa-clock',
    'fas fa-clone',
    'fas fa-close',
    'fas fa-cloud',
    'fas fa-cloud-download',
    'fas fa-cloud-upload',
    'fas fa-code',
    'fas fa-code-fork',
    'fas fa-coffee',
    'fas fa-cog',
    'fas fa-cogs',
    'fas fa-comment',
    'fas fa-commenting',
    'fas fa-comments',
    'fas fa-compass',
    'fas fa-copyright',
    'fas fa-creative-commons',
    'fas fa-credit-card',
    'fas fa-credit-card-alt',
    'fas fa-crop',
    'fas fa-crosshairs',
    'fas fa-cube',
    'fas fa-cubes',
    'fas fa-cutlery',
    'fas fa-dashboard',
    'fas fa-database',
    'fas fa-deaf',
    'fas fa-deafness',
    'fas fa-desktop',
    'fas fa-diamond',
    'fas fa-dot-circle',
    'fas fa-download',
    'fas fa-drivers-license',
    'fas fa-edit',
    'fas fa-ellipsis-h',
    'fas fa-ellipsis-v',
    'fas fa-envelope',
    'fas fa-envelope',
    'fas fa-envelope-open',
    'fas fa-envelope-square',
    'fas fa-eraser',
    'fas fa-exchange',
    'fas fa-exclamation',
    'fas fa-exclamation-circle',
    'fas fa-exclamation-triangle',
    'fas fa-external-link',
    'fas fa-external-link-square',
    'fas fa-eye',
    'fas fa-eye-slash',
    'fas fa-eyedropper',
    'fas fa-fax',
    'fas fa-feed',
    'fas fa-female',
    'fas fa-fighter-jet',
    'fas fa-file-archive',
    'fas fa-file-audio',
    'fas fa-file-code',
    'fas fa-file-excel',
    'fas fa-file-image',
    'fas fa-file-pdf',
    'fas fa-file-powerpoint',
    'fas fa-file-video',
    'fas fa-file-word',
    'fas fa-file-zipper',
    'fas fa-film',
    'fas fa-filter',
    'fas fa-fire',
    'fas fa-fire-extinguisher',
    'fas fa-flag',
    'fas fa-flag-checkered',
    'fas fa-flask',
    'fas fa-folder',
    'fas fa-folder-open',
    'fas fa-frown',
    'fas fa-futbol',
    'fas fa-gamepad',
    'fas fa-gavel',
    'fas fa-gear',
    'fas fa-gears',
    'fas fa-gift',
    'fas fa-glass-water',
    'fas fa-globe',
    'fas fa-graduation-cap',
    'fas fa-hand-lizard',
    'fas fa-hand-paper',
    'fas fa-hand-peace',
    'fas fa-hand-pointer',
    'fas fa-hand-rock',
    'fas fa-hand-scissors',
    'fas fa-hand-spock',
    'fas fa-handshake',
    'fas fa-hard-of-hearing',
    'fas fa-hashtag',
    'fas fa-hdd',
    'fas fa-headphones',
    'fas fa-heart',
    'fas fa-heartbeat',
    'fas fa-history',
    'fas fa-home',
    'fas fa-hotel',
    'fas fa-hourglass',
    'fas fa-hourglass-end',
    'fas fa-hourglass-half',
    'fas fa-hourglass-start',
    'fas fa-i-cursor',
    'fas fa-id-badge',
    'fas fa-id-card',
    'fas fa-image',
    'fas fa-inbox',
    'fas fa-industry',
    'fas fa-info',
    'fas fa-info-circle',
    'fas fa-institution',
    'fas fa-key',
    'fas fa-keyboard',
    'fas fa-language',
    'fas fa-laptop',
    'fas fa-leaf',
    'fas fa-legal',
    'fas fa-lemon',
    'fas fa-level-down',
    'fas fa-level-up',
    'fas fa-life-ring',
    'fas fa-lightbulb',
    'fas fa-line-chart',
    'fas fa-location-arrow',
    'fas fa-lock',
    'fas fa-low-vision',
    'fas fa-magic',
    'fas fa-magnet',
    'fas fa-mail-forward',
    'fas fa-mail-reply',
    'fas fa-mail-reply-all',
    'fas fa-male',
    'fas fa-map',
    'fas fa-map-marker',
    'fas fa-map-pin',
    'fas fa-map-signs',
    'fas fa-meh',
    'fas fa-microchip',
    'fas fa-microphone',
    'fas fa-microphone-slash',
    'fas fa-minus',
    'fas fa-minus-circle',
    'fas fa-minus-square',
    'fas fa-mobile',
    'fas fa-money-bill',
    'fas fa-moon',
    'fas fa-mortar-board',
    'fas fa-motorcycle',
    'fas fa-mouse-pointer',
    'fas fa-music',
    'fas fa-navicon',
    'fas fa-book-open',
    'fas fa-object-group',
    'fas fa-object-ungroup',
    'fas fa-paint-brush',
    'fas fa-paper-plane',
    'fas fa-paw',
    'fas fa-pencil',
    'fas fa-pencil-square',
    'fas fa-percent',
    'fas fa-phone',
    'fas fa-phone-square',
    'fas fa-pie-chart',
    'fas fa-plane',
    'fas fa-plug',
    'fas fa-plus',
    'fas fa-plus-circle',
    'fas fa-plus-square',
    'fas fa-podcast',
    'fas fa-power-off',
    'fas fa-print',
    'fas fa-puzzle-piece',
    'fas fa-qrcode',
    'fas fa-question',
    'fas fa-question-circle',
    'fas fa-quote-left',
    'fas fa-quote-right',
    'fas fa-random',
    'fas fa-recycle',
    'fas fa-refresh',
    'fas fa-registered',
    'fas fa-remove',
    'fas fa-reorder',
    'fas fa-reply',
    'fas fa-reply-all',
    'fas fa-retweet',
    'fas fa-road',
    'fas fa-rocket',
    'fas fa-rss',
    'fas fa-rss-square',
    'fas fa-search',
    'fas fa-search-minus',
    'fas fa-search-plus',
    'fas fa-server',
    'fas fa-share',
    'fas fa-share-alt',
    'fas fa-share-alt-square',
    'fas fa-share-square',
    'fas fa-shield',
    'fas fa-ship',
    'fas fa-shopping-bag',
    'fas fa-shopping-basket',
    'fas fa-shopping-cart',
    'fas fa-shower',
    'fas fa-sign-in',
    'fas fa-sign-language',
    'fas fa-sign-out',
    'fas fa-signal',
    'fas fa-signing',
    'fas fa-sitemap',
    'fas fa-sliders',
    'fas fa-smile',
    'fas fa-snowflake',
    'fas fa-soccer-ball',
    'fas fa-sort',
    'fas fa-sort-alpha-asc',
    'fas fa-sort-alpha-desc',
    'fas fa-sort-amount-asc',
    'fas fa-sort-amount-desc',
    'fas fa-sort-asc',
    'fas fa-sort-desc',
    'fas fa-sort-down',
    'fas fa-sort-numeric-asc',
    'fas fa-sort-numeric-desc',
    'fas fa-sort-up',
    'fas fa-space-shuttle',
    'fas fa-spinner',
    'fas fa-spoon',
    'fas fa-square',
    'fas fa-star',
    'fas fa-star-half',
    'fas fa-sticky-note',
    'fas fa-street-view',
    'fas fa-suitcase',
    'fas fa-sun',
    'fas fa-tablet',
    'fas fa-tachometer',
    'fas fa-tag',
    'fas fa-tags',
    'fas fa-tasks',
    'fas fa-taxi',
    'fas fa-television',
    'fas fa-terminal',
    'fas fa-thermometer',
    'fas fa-thermometer-0',
    'fas fa-thermometer-1',
    'fas fa-thermometer-2',
    'fas fa-thermometer-3',
    'fas fa-thermometer-4',
    'fas fa-thermometer-empty',
    'fas fa-thermometer-full',
    'fas fa-thermometer-half',
    'fas fa-thermometer-quarter',
    'fas fa-thermometer-three-quarters',
    'fas fa-thumb-tack',
    'fas fa-thumbs-down',
    'fas fa-thumbs-up',
    'fas fa-ticket',
    'fas fa-times',
    'fas fa-times-circle',
    'fas fa-times-rectangle',
    'fas fa-tint',
    'fas fa-toggle-off',
    'fas fa-toggle-on',
    'fas fa-trademark',
    'fas fa-trash',
    'fas fa-tree',
    'fas fa-trophy',
    'fas fa-truck',
    'fas fa-tty',
    'fas fa-tv',
    'fas fa-umbrella',
    'fas fa-universal-access',
    'fas fa-university',
    'fas fa-unlock',
    'fas fa-unlock-alt',
    'fas fa-unsorted',
    'fas fa-upload',
    'fas fa-user',
    'fas fa-user-circle',
    'fas fa-user-plus',
    'fas fa-user-secret',
    'fas fa-user-times',
    'fas fa-users',
    'fas fa-vcard',
    'fas fa-video-camera',
    'fas fa-volume-control-phone',
    'fas fa-volume-down',
    'fas fa-volume-off',
    'fas fa-volume-up',
    'fas fa-warning',
    'fas fa-wheelchair',
    'fas fa-wheelchair-alt',
    'fas fa-wifi',
    'fas fa-window-close',
    'fas fa-window-maximize',
    'fas fa-window-minimize',
    'fas fa-window-restore',
    'fas fa-wrench',
  ];

  private cache = new Map<string, Observable<SafeHtml>>();
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  getSvgCodeByKey(iconKey: string) {
    return this.getSvgCode(`${this.basePath}${iconKey}.svg`);
  }

  getSvgCode(path: string): Observable<SafeHtml> | undefined {
    if (this.cache.has(path)) {
      return this.cache.get(path);
    }

    const safeIcon = this.http.get(path, { responseType: 'text' }).pipe(
      map(svgContent => this.sanitizer.bypassSecurityTrustHtml(svgContent)),
      shareReplay(1)
    );

    this.cache.set(path, safeIcon);
    return safeIcon;
  }

  getIcons(): MakiIcon[] {
    return this.poiIcons.map((iconKey: string) => {
      return {
        path: `${this.basePath}${iconKey}.svg`,
        svg: this.getSvgCode(`${this.basePath}${iconKey}.svg`),
        key: iconKey,
      };
    });
  }

  getThemeIcons(): FaIcon[] {
    return this.themeIcons.map((iconKey: string) => {
      return {
        keyWords: [],
        key: iconKey,
      };
    });
  }
}
